import StarRatingDisplay from './StarRatingDisplay'

export interface RatingBreakdownBucket {
  rating: number
  count: number
  percentage: number
}

export default function RatingBreakdown({
  averageRating,
  totalReviews,
  buckets,
  reviewsLabel,
}: {
  averageRating: number
  totalReviews: number
  buckets: RatingBreakdownBucket[]
  reviewsLabel: string
}) {
  return (
    <div className="grid gap-5 lg:grid-cols-[220px_minmax(0,1fr)]">
      <div className="rounded-[1.5rem] border border-slate-200 bg-slate-50 p-5">
        <p className="text-4xl font-black text-slate-950">{averageRating.toFixed(1)}</p>
        <div className="mt-3">
          <StarRatingDisplay rating={averageRating} />
        </div>
        <p className="mt-3 text-sm text-slate-500">
          {totalReviews} {reviewsLabel}
        </p>
      </div>

      <div className="space-y-3">
        {buckets.map((bucket) => (
          <div key={bucket.rating} className="grid grid-cols-[48px_minmax(0,1fr)_56px] items-center gap-3 text-sm">
            <span className="font-semibold text-slate-700">{bucket.rating}★</span>
            <div className="h-2 overflow-hidden rounded-full bg-slate-200">
              <div
                className="h-full rounded-full bg-amber-400"
                style={{ width: `${bucket.percentage}%` }}
              />
            </div>
            <span className="text-right text-slate-500">{bucket.count}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
